import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  (theme) => ({
    fullPill: {
      letterSpacing: '1.2px',
      position: 'absolute',
      bottom: '-8px',
      background: theme.colors.peach,
      padding: '0 4px',
      borderRadius: '100px',
      zIndex: 1,
      height: '20px',
      fontWeight: theme.fontWeights.medium,
      color: theme.colors.charcoal,
      pointerEvents: 'none',
    },
    fullDot: {
      position: 'absolute',
      top: '5px',
      background: '#D53C2F', // TODO get from settings
      borderRadius: '100px',
      zIndex: 1,
      height: '7px',
      width: '7px',
      pointerEvents: 'none',

      [theme.breakpoints.down('xs')]: {
        top: '3px',
        height: '4px',
        width: '4px',
      },
    },
  }),
  { name: 'Calendar' },
);

export default useStyles;
